// extracted by mini-css-extract-plugin
export var fileUpload = "_fs-1";
export var modalButton = "_fs-0";